module.exports = __webpack_public_path__ + "static/media/news4-2.d9e9b5e8.jpg";